import { render, staticRenderFns } from "./doris-conf-form.vue?vue&type=template&id=2b5101f1&scoped=true&"
import script from "./doris-conf-form.vue?vue&type=script&lang=ts&"
export * from "./doris-conf-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5101f1",
  null
  
)

export default component.exports